




























































































/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue } from 'vue-property-decorator';
import LayoutContent from '@/components/LayoutContent.vue';
import FormInput from '@/components/FormInput.vue';
import Button from '@/components/Button.vue';
import Select from '@/components/Select.vue';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import api, { apiSandbox } from '@/libs/api';
import { AxiosError } from 'axios';
import VTooltip from 'v-tooltip';

Vue.use(VTooltip);

@Component({
  components: {
    LayoutContent,
    FormInput,
    Button,
    Select,
  },
})

export default class Step3 extends Vue {
  @Prop(Object) data!: any;
  flagUrl = this.data.detailMerchant.payment_url;
  inquiryPath = this.data.detailMerchant.inquiry_path;
  channelId = this.data.channel_id;
  serviceCode = this.data.service_code;
  selectedService = '';
  optTooltip = {
    placement: 'bottom-end',
    classes: 'tooltip-style',
    delay: { show: 500, hide: 100 },
    offset: '5',
    // show: true,
    // trigger: 'manual',
  }

  listPaymentFlag: any = {
    easyInvoice: {
      1011: {
        name: 'Permata VA',
        flagUrl: 'https://paytest.bayarind.id:3002/payment/pvaflag',
        inquiryPath: 'https://paytest.bayarind.id:3002/payment/pvainq',
      },
      1012: {
        name: 'Permata Net',
        flagUrl: 'https://paytest.bayarind.id:3002/payment/pvaflag',
        inquiryPath: 'https://paytest.bayarind.id:3002/payment/pvainq',
      },
      1021: {
        name: 'BCA VA',
        flagUrl: 'https://paytest.bayarind.id:3002/payment/bcavasingflag',
      },
      1077: {
        name: 'LinkAja',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/tcashflag',
      },
      1032: {
        name: 'Mandiri VA',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/mvaflag',
      },
      1081: {
        name: 'OCTO Click',
        flagUrl: 'https://paytest.bayarind.id:3002/payment/cimbClickflag',
      },
      1062: {
        name: 'BRI VA',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/brivaflag',
      },
      1042: {
        name: 'BNI VA',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/bnivaflag',
      },
      1043: {
        name: 'BSI VA',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/bnisyariahflag',
      },
      1074: {
        name: 'Danamon VA',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/danamonvaflag',
      },
      1052: {
        name: 'Maybank VA',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/maybankvaflag',
      },
      1022: {
        name: 'BCA KlikPay',
        flagUrl: 'https://paytest.bayarind.id:3002/payment/klikpayflag',
      },
      1023: {
        name: 'Klik BCA',
        flagUrl: 'https://paytest.bayarind.id:3002/payment/klikbcaflag',
      },
      1061: {
        name: 'BRIMo',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/epaybriflag',
      },
      1041: {
        name: 'BNI Ipay',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/bniipayflag',
      },
      1083: {
        name: 'Bayarind',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/bayarindflag',
      },
      1084: {
        name: 'DANA',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/danaflag',
      },
      1024: {
        name: 'BCA Sakuku',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/bcasakukuflag',
      },
      1073: {
        name: 'Kredivo',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/kredivoflag',
      },
      1078: {
        name: 'Home Credit',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/homecreditflag',
      },
      1080: {
        name: 'Indodana',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/indodanaflag',
      },
      1085: {
        name: 'ShopeePay',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/shopeepayflag',
      },
      1086: {
        name: 'OVO',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/ovoflag',
      },
      1087: {
        name: 'Alfamart',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/alfamartflag',
      },
      1088: {
        name: 'Atome',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/atomeflag',
      },
      1089: {
        name: 'QRIS',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/qrisflag',
      },
      1090: {
        name: 'BNC VA',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/bncvaflag',
      },
      1026: {
        name: 'BLU',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/blubcaflag',
      },
      1092: {
        name: 'BTN VA',
        flagUrl: 'https://paytest.bayarind.id:3002/paymentflag/btnvaflag',
      },
      2002: {
        name: 'Credit Card',
        flagUrl: 'https://paytest.bayarind.id:3002/payment/ccflag',
      },
    },
    onePay: 'https://paytest.bayarind.id:3001/onepay/notification',
  }

  listPaymentFlagProd: any = {
    easyInvoice: {
      1011: {
        name: 'Permata VA',
        flagUrl: 'https://pay.sprintasia.net:8443/payment/pvaflag',
        inquiryPath: 'https://pay.sprintasia.net:8443/payment/pvainq',
      },
      1012: {
        name: 'Permata Net',
        flagUrl: 'https://pay.sprintasia.net:8443/payment/pvaflag',
        inquiryPath: 'https://pay.sprintasia.net:8443/payment/pvainq',
      },
      1021: {
        name: 'BCA VA',
        flagUrl: 'https://pay.sprintasia.net:8443/payment/bcavasingflag',
      },
      1077: {
        name: 'LinkAja',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/tcashflag',
      },
      1032: {
        name: 'Mandiri VA',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/mvaflag',
      },
      1081: {
        name: 'OCTO Click',
        flagUrl: 'https://pay.sprintasia.net:8443/payment/cimbClickflag',
      },
      1062: {
        name: 'BRI VA',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/brivaflag',
      },
      1042: {
        name: 'BNI VA',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/bnivaflag',
      },
      1043: {
        name: 'BSI VA',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/bnisyariahflag',
      },
      1074: {
        name: 'Danamon VA',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/danamonvaflag',
      },
      1052: {
        name: 'Maybank VA',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/maybankvaflag',
      },
      1022: {
        name: 'BCA KlikPay',
        flagUrl: 'https://pay.sprintasia.net:8443/payment/klikpayflag',
      },
      1023: {
        name: 'Klik BCA',
        flagUrl: 'https://pay.sprintasia.net:8443/payment/klikbcaflag',
      },
      1061: {
        name: 'BRIMo',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/epaybriflag',
      },
      1041: {
        name: 'BNI Ipay',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/bniipayflag',
      },
      1083: {
        name: 'Bayarind',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/bayarindflag',
      },
      1084: {
        name: 'DANA',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/danaflag',
      },
      1024: {
        name: 'BCA Sakuku',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/bcasakukuflag',
      },
      1073: {
        name: 'Kredivo',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/kredivoflag',
      },
      1078: {
        name: 'Home Credit',
        flagUrl: ' ',
      },
      1080: {
        name: 'Indodana',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/indodanaflag',
      },
      1085: {
        name: 'ShopeePay',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/shopeepayflag',
      },
      1086: {
        name: 'OVO',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/ovoflag',
      },
      1087: {
        name: 'Alfamart',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/alfamartflag',
      },
      1088: {
        name: 'Atome',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/atomeflag',
      },
      1089: {
        name: 'QRIS',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/qrisflag',
      },
      1090: {
        name: 'BNC VA',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/bncvaflag',
      },
      1026: {
        name: 'BLU',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/blubcaflag',
      },
      1092: {
        name: 'BTN VA',
        flagUrl: 'https://pay.sprintasia.net:8443/paymentflag/btnvaflag',
      },
      2002: {
        name: 'Credit Card',
        flagUrl: 'https://pay.sprintasia.net:8443/payment/ccflag',
      },
    },
    onePay: 'https://onepay.sprintasia.net/onepay/notification',
  }

  mounted() {
    if (/(:3002\/payment)|(:8443\/payment)/.test(this.flagUrl)) {
      this.selectedService = 'Easy Invoice';
    } else if (/(:3001\/onepay)|(net\/onepay)/.test(this.flagUrl)) {
      this.selectedService = 'Onepay';
    } else {
      this.selectedService = 'Custom Payment Flag URL';
    }
  }

  cancel() {
    this.flagUrl = this.data.detailMerchant.payment_url;
    this.inquiryPath = this.data.detailMerchant.inquiry_path;
    this.channelId = this.data.detailMerchant.channel_id;
    this.serviceCode = this.data.service_code;
  }

  async updateChannel() {
    try {
      await apiSandbox.put('/merchant/channel', {
        channel_id: this.channelId,
        service_code: this.serviceCode,
        payment_url: this.flagUrl,
        inquiry_url: this.inquiryPath,
      });

      showToast(ToastType.SUCCESS, 'Congratulations',
        'Setting URL is already updated successfully');
    } catch (err) {
      console.error(err);
      showToast(
        ToastType.FAILED,
        `Error [${(err as AxiosError).response?.status}]`,
        'Failed to Update',
      );
    }
  }

  switchPaymentFlag() {
    try {
      switch (this.selectedService) {
        case 'Easy Invoice': {
          this.flagUrl = this.listPaymentFlag.easyInvoice[this.serviceCode].flagUrl;
          if (/1011|1012/.test(this.serviceCode)) {
            this.inquiryPath = this.listPaymentFlag.easyInvoice[this.serviceCode].inquiryPath;
          }
          break;
        }
        case 'Onepay': {
          this.flagUrl = this.listPaymentFlag.onePay;
          break;
        }
        default: {
          this.flagUrl = this.data.detailMerchant.payment_url;
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
}
